import { render } from "./Equation.vue?vue&type=template&id=0ebc5770"
import script from "./Equation.vue?vue&type=script&lang=js"
export * from "./Equation.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.29.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__